module.exports = {"id":"216325","name":"Angus Gunn","rating":"71","photo":"./data/images/photos/3/216325.png","club":{"name":"Norwich City","logo":"./data/images/clubs/NorwichCity.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AngusGunn0.json
// module id = 422
// module chunks = 0